export enum FeatureFlagKey {
  ALLOW_ADD_BUYERS = 'allowAddBuyers',
  ALLOW_ADD_SELLERS = 'allowAddSellers',
  ALLOW_SELLER_TEN99 = 'allowSellerTen99',
  SERVER_SIDE_TABLE = 'featureServerSideTable',
  VIEW_PARTIES_REDESIGN = 'viewPartiesRedesign',
  ALLOW_MASTER_ORDER_TOGGLE = 'allowMasterOrderToggle',
  ALLOW_TEN99_REPORTING = 'allowTen99Reporting',
  ALLOW_ORDER_FUNDING_VIEW = 'allowOrderFundingView',
}

export const defaultFeatureFlagValues = {
  [FeatureFlagKey.ALLOW_ADD_BUYERS]: false,
  [FeatureFlagKey.ALLOW_ADD_SELLERS]: false,
  [FeatureFlagKey.ALLOW_SELLER_TEN99]: false,
  [FeatureFlagKey.SERVER_SIDE_TABLE]: false,
  [FeatureFlagKey.VIEW_PARTIES_REDESIGN]: false,
  [FeatureFlagKey.ALLOW_MASTER_ORDER_TOGGLE]: true,
  [FeatureFlagKey.ALLOW_TEN99_REPORTING]: false,
  [FeatureFlagKey.ALLOW_ORDER_FUNDING_VIEW]: false,
};
